var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 24,
    fill: "#FFC93C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 42.3984C20.8975 42.3984 21.625 43.126 21.625 44.0234V47.5C21.625 49.0878 22.9122 50.375 24.5 50.375H27.9766C28.874 50.375 29.6016 51.1025 29.6016 52C29.6016 52.8975 28.874 53.625 27.9766 53.625H24.5C21.1173 53.625 18.375 50.8827 18.375 47.5V44.0234L18.3838 43.8574C18.4669 43.0379 19.1585 42.3984 20 42.3984ZM52 42.3984C52.8975 42.3984 53.625 43.126 53.625 44.0234V47.5C53.625 50.8827 50.8827 53.625 47.5 53.625H44.0234C43.126 53.625 42.3984 52.8975 42.3984 52C42.3984 51.1025 43.126 50.375 44.0234 50.375H47.5C49.0878 50.375 50.375 49.0878 50.375 47.5V44.0234C50.375 43.126 51.1025 42.3984 52 42.3984ZM24.5 18.375H27.9766C28.874 18.375 29.6016 19.1025 29.6016 20C29.6016 20.8975 28.874 21.625 27.9766 21.625H24.5C22.9122 21.625 21.625 22.9122 21.625 24.5V27.9766C21.625 28.874 20.8975 29.6016 20 29.6016C19.1025 29.6016 18.375 28.874 18.375 27.9766V24.5C18.375 21.1173 21.1173 18.375 24.5 18.375ZM44.0234 18.375H47.5C50.8827 18.375 53.625 21.1173 53.625 24.5V27.9766C53.625 28.874 52.8975 29.6016 52 29.6016C51.1025 29.6016 50.375 28.874 50.375 27.9766V24.5C50.375 22.9122 49.0878 21.625 47.5 21.625H44.0234C43.126 21.625 42.3984 20.8975 42.3984 20C42.3984 19.1025 43.126 18.375 44.0234 18.375Z",
    fill: "#142953",
    stroke: "#FCD647",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30.9063V33.9531M42.711 30.9062V33.9531M36.1094 30.9062V38.3824C36.1094 38.881 35.7052 39.2852 35.2066 39.2852H33.5703M29.5078 43.7145C31.3698 45.7458 36.4649 48.5895 41.9493 43.7145",
    stroke: "#142953",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceId);
export default __webpack_public_path__ + "static/media/faceId.be7cc989c3c16ba687687b20ed1d790e.svg";
export { ForwardRef as ReactComponent };